import type { ComponentProps } from "react";

import { cn } from "./cn";

/** A grey block that stands where content is loading. It is decoration: say "Loading" in text next to it (`AsyncState` does). */
export function Skeleton({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      aria-hidden="true"
      className={cn("animate-pulse rounded-sm bg-skeleton", className)}
      {...props}
    />
  );
}
